import React, { useEffect, useState } from "react"
import { MainMenuItem } from "../../hooks/useMainMenu"
import { MobileMenuWrapper, StyledBurger, MobileMenuItemWrapper, BurgerWrapper, LogoWrapper, Logo, HeaderWrapper, Wrapper } from './mobileNav.style'
import { Link } from "gatsby"
import { up, down, between, only } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import MenuItem from "./menuItem";

type Props = {
  items: MainMenuItem[],
  logoUrl: {
    external: boolean,
    url: string
  },
}

const MobileNav = ({ items, logoUrl }: Props) => {

  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      location.hash = ""
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.position = 'unset';
      document.body.style.width = 'unset';
      document.body.style.height = 'unset';
    }
  }, [open])


  return (
    <Wrapper>
      {open && <LogoWrapper>
        {!logoUrl.external && <Link to={logoUrl.url}>
          <Logo
            alt="Interia - Twoje Wszystko"
            title="Interia - Twoje Wszystko"
            src="/footer-logo.svg"
            width="300" />
        </Link>}
        {logoUrl.external && <a href={logoUrl.url}>
          <Logo
            alt="Interia - Twoje Wszystko"
            title="Interia - Twoje Wszystko"
            src="/footer-logo.svg"
            width="300" />
        </a>}
      </LogoWrapper>}
      <BurgerWrapper>
        <StyledBurger aria-label="Menu" onClick={() => { setOpen(!open) }} open={open}>
          <div />
          <div />
          <div />
        </StyledBurger>
      </BurgerWrapper>
      <MobileMenuWrapper open={open}>
        {items.map((menuItem, key) => {
          return <MenuItem onClick={() => { setOpen(false) }} active={false} key={key} menuItem={menuItem} scrollY={0} />
        })}
      </MobileMenuWrapper>
    </Wrapper>
  )
}

export default MobileNav 
